import { render, staticRenderFns } from "./InstitucionesLayout.vue?vue&type=template&id=772607f6&scoped=true"
import script from "./InstitucionesLayout.vue?vue&type=script&lang=js"
export * from "./InstitucionesLayout.vue?vue&type=script&lang=js"
import style0 from "./InstitucionesLayout.vue?vue&type=style&index=0&id=772607f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772607f6",
  null
  
)

export default component.exports